export default __webpack_public_path__ + "static/media/3661.10972445.png";